import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import './i18n' // Initialize i18n

// Brick is dark-only. The `.dark` class is applied at the document root so
// any shadcn / Tailwind utilities that key off `.dark` resolve correctly.
document.documentElement.classList.add('dark');

createRoot(document.getElementById("root")!).render(<App />);
